import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import { AxiosError } from "axios";
import apiClient from ".";
import { extractErrorMessage } from "./ErrorHandler";

interface UseDeleteDataProps<T, P = void> {
  url: string;
  options?: {
    onSuccess?: (data: T) => void;
    onError?: (error: AxiosError) => void;
  };
}

export const useDeleteData = <T, P = void>({ url, options }: UseDeleteDataProps<T, P>) => {
  return useMutation<T, AxiosError, P | void>({
    mutationFn: async (payload?: P) => {
      const response = await apiClient.delete<T>(url, payload ? { data: payload } : undefined);
      return response.data;
    },
    onError: (error) => {
      const errorMessage = extractErrorMessage(error);
      message.error(errorMessage);
      if (options?.onError) options.onError(error);
    },
    ...options,
  });
};
